import React, { Component, createRef } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import logo from "../../logo.svg";
import "./css/NavMain.scss";
import navitems from "../../navitems.json";
import AuthContext from "../../context/AuthContext";
import { withRouter } from "../../utils/withRouter"; // Create a helper function for navigation

class NavMain extends Component {
    static contextType = AuthContext; // Attach AuthContext

    constructor(props) {
        super(props);
        this.state = {
            clickedElement: null,
            isOpen: window.matchMedia("(max-width: 768px)").matches ? false : true,
        };
        this.navRef = createRef();
    }

    componentDidMount() {
        document.addEventListener("click", this.handleOutsideClick);
        this.setupResizeObservers();
    }

    componentWillUnmount() {
        document.removeEventListener("click", this.handleOutsideClick);
        if (this.resizeObservers) {
            this.resizeObservers.forEach(observer => observer.disconnect());
        }
    }

    setupResizeObservers = () => {
        this.resizeObservers = [];
        setTimeout(() => {
            document.querySelectorAll(".navigation__children").forEach((child) => {
                const observer = new ResizeObserver(entries => {
                    for (let entry of entries) {
                        const height = entry.contentRect.height;
                        const parent = entry.target.closest(".navigation__children");

                        if (parent && height > 400 && window.matchMedia("(max-width: 768px)").matches) {
                            parent.style.marginTop = `-${height / 2}px`;
                        }
                    }
                });
                observer.observe(child);
                this.resizeObservers.push(observer);
            });
        }, 100);
    };

    handleClick = (index) => {
        this.setState({ clickedElement: `nav-parent${index}` }, () => {
            this.setupResizeObservers(); // Recalculate on click
        });
    };

    handleToggle = () => {
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen,
        }));
    };

    handleOutsideClick = (event) => {
        if (!event.target.closest("#navigation")) {
            document.querySelectorAll(".navigation__parent").forEach((el) => {
                el.classList.remove("active-temp");
            });
        }
    };

    handleLogout = () => {
        const { logout } = this.context; // Get logout function from AuthContext
        logout(); // Perform logout
        this.props.navigate("/login"); // Redirect to login
    };

    render() {
        const { clickedElement, isOpen } = this.state;
        const { slug, parent } = this.props;

        return (
            <div id="navigation" className={isOpen ? "nav-open" : "nav-close"} ref={this.navRef}>
                <Container>
                    <Row>
                        <Col className="logo">
                            <a href="/">
                                <img src={logo} alt="logo" />
                            </a>
                        </Col>
                        <Col className="mobile-nav hide-desk">
                            <Button href="#" onClick={this.handleToggle}>
                                {isOpen ? (
                                    <i className="fa-solid fa-times"></i>
                                ) : (
                                    <i className="fa-solid fa-bars"></i>
                                )}
                            </Button>
                        </Col>
                    </Row>
                    <Row className="navigation__items">
                        <Col>
                            {navitems.map((item, index) => {
                                const isActive =
                                    clickedElement === `nav-parent${item.id}` ||
                                    slug === item.slug ||
                                    parseInt(parent) === item.id;

                                const isActiveTemp = clickedElement === `nav-parent${item.id}`;

                                return (
                                    <Row
                                        key={index}
                                        className={`navigation__parent ${isActive ? "active" : ""} ${isActiveTemp ? "active-temp" : ""}`}
                                        id={`nav-parent${item.id}`}
                                        onClick={() => this.handleClick(item.id)}
                                    >
                                        <a href={item.slug === null ? "#" : `/${item.slug}`}>
                                            <i className={item.icon}></i> <span>{item.name}</span>
                                        </a>
                                        <div className="navigation__children">
                                            {item.subitem.map((subitem, subIndex) => (
                                                <Row key={subIndex} className="navigation__child">
                                                    <a
                                                        href={`/${subitem.slug}`}
                                                        data-slug={subitem.slug}
                                                        className={slug === subitem.slug ? "active" : ""}
                                                    >
                                                        {subitem.name}
                                                    </a>
                                                </Row>
                                            ))}
                                        </div>
                                    </Row>
                                );
                            })}
                            {/* Logout Button */}
                            <Row className="navigation__parent">
                                <a href="/login" role="button" onClick={(e) => { e.preventDefault(); this.handleLogout(); }} className="text-danger">
                                    <i className="fa-solid fa-right-from-bracket"></i> <span>Logout</span>
                                </a>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withRouter(NavMain); // Wrap with withRouter to use navigation
